import { dailnumber, disconnectContact } from '@/ccp/actions';
import { followUpRecords } from '@/pages/Business/service';
import { useAppSelector } from '@/redux/hooks/useAppSelector';
import { getReduxStore } from '@/redux/store';
import { FormattedMessage } from '@umijs/max';
import { Button, Descriptions, Row, Spin } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

const glowing = keyframes`
  0% { background-color: #2ba805; box-shadow: 0 0 5px #2ba805; }
  50% { background-color: #49e819; box-shadow: 0 0 20px #49e819; }
  100% { background-color: #2ba805; box-shadow: 0 0 5px #2ba805; }
`;

const GlowingButton = styled(Button)<{ glowing?: boolean }>`
  cursor: pointer;
  margin: 20px 0;
  animation: ${(props) =>
    props.glowing
      ? css`
          ${glowing} 1300ms infinite
        `
      : 'none'};
`;

const ContainerDiv = styled.div`
  width: 400px;
  height: 600px;
`;

interface AwsConnectModalProps {
  phone?: string;
  connectModalOpen?: any;
}
const phoneHide = (phoneNumber?: any) => {
  if (phoneNumber.length > 9) {
    return phoneNumber.substring(0, 3) + '*****' + phoneNumber.substring(8, phoneNumber.length);
  } else {
    return phoneNumber.substring(0, 2) + '***' + phoneNumber.substring(5, phoneNumber.length);
  }
};

const AwsConnectModal: React.FC<AwsConnectModalProps> = (props) => {
  const store = getReduxStore();
  const { connectModalOpen } = props;
  const connectStatus = useAppSelector((state) => state.connect.status);
  const phoneNumber = useAppSelector((state) => state.connect.phoneNumber);
  const phoneHidemsg = phoneHide(phoneNumber);
  console.log('phoneHidemsg', phoneHidemsg);
  const contactName = useAppSelector((state) => state.connect.contactName);
  const bid = useAppSelector((state) => state.connect.bid);
  const prevDependencyRef = useRef('INIT');
  const [callingDisabled, setCallingDisabled] = useState<any>(false);

  // useEffect(() => {
  //   if (prevDependencyRef.current === 'INIT' && connectStatus !== 'INIT') {
  //     dailnumber(phone);
  //   }
  //   prevDependencyRef.current = connectStatus;
  // }, [connectStatus]);

  // let checkTimer: any = null;
  let seconds = 0;
  let minutes = 0;
  let hours = 0;
  let state = '';
  const [checkTimer, setCheckTimer] = useState<any>(null);
  const [isShowDuration, setisShowDuration] = useState<any>(false);
  const [time, setTime] = useState<any>('0H : 0M : 0S');
  // const [seconds, setSeconds] = useState<any>(0);
  // const [minutes, setMinutes] = useState<any>(0);
  // const [hours, setHours] = useState<any>(0);
  // const [state, setState] = useState<any>('');

  const updateDuration = () => {
    seconds++;
    if (seconds >= 60) {
      seconds = 0;
      minutes++;
    }
    if (minutes >= 60) {
      minutes = 0;
      hours++;
    }
    const durationString = `${hours}H : ${minutes}M : ${seconds}S`;
    setTime(durationString);
    let timerDiv: any = document.getElementById('duration-indicator');
    // console.log('timerDiv', timerDiv)
    if (timerDiv) {
      timerDiv.textContent = state + ' ' + ' ' + durationString;
    } else {
      return;
    }
    // console.log('checkTimer', checkTimer)
    // console.log('durationString', durationString);
    setCheckTimer(setTimeout(updateDuration, 1000));
  };

  const restart_checker = (display: any, s?: any) => {
    console.log('restart_checker');
    if (checkTimer !== null) {
      setCheckTimer(null);
      setCheckTimer(clearTimeout(checkTimer));
    }

    state = s;

    if (display) {
      hours = 0;
      minutes = 0;
      seconds = 0;
      setisShowDuration(true);
      setTimeout(updateDuration, 0);
      // updateDuration();
    } else {
      hours = 0;
      minutes = 0;
      seconds = 0;
      // timerDiv.style = 'display:none';
      setisShowDuration(false);
      setCheckTimer(null);
      setCheckTimer(clearTimeout(checkTimer));
      // const a = session.contact.getContactId()
    }
  };

  useEffect(() => {
    console.log('connectModalOpen', connectModalOpen);
    // if (!connectModalOpen) {
    //   disconnectContact();
    //   restart_checker(false);
    //   // setCallingDisabled(false);
    // }
    disconnectContact();
    restart_checker(false);
    setCallingDisabled(false);
  }, [connectModalOpen]);

  const lastCall = useRef(0);
  const throttle = (callback: any, delay: any) => {
    return (...args: any) => {
      const currentTime = new Date().getTime();
      if (currentTime - lastCall.current >= delay) {
        callback(...args);
        lastCall.current = currentTime;
      }
    };
  };

  const handUpCallIng = (contactId: any) => {
    console.log('11111111subscribe', contactId);
    restart_checker(false);
    setCallingDisabled(false);
    followUpRecords({
      module: 'call',
      type: 6,
      bid: bid, // 商机id
      data: contactId, // connectId
      changeContent: time, // 通话时长
    }).then((res) => {
      if (res.success) {
        // message.success('Withdrawn successfully');
      } else {
        // message.error(res.message);
      }
    });
  };

  const throttleHandUpCallIng = throttle(handUpCallIng, 5000); // 防抖处理

  useEffect(() => {
    store.subscribe(() => {
      const contactId = store.getState().connect.contactId;
      const setcontactIdBefore1 = sessionStorage.getItem('a-e-d-k-y-n-cId') as string;
      console.log('11111111subscribe1contactId', contactId, setcontactIdBefore1, contactId !== setcontactIdBefore1);
      if (contactId && contactId !== setcontactIdBefore1) {
        throttleHandUpCallIng(contactId);
      }
    });
  }, []);

  return (
    <Row justify={'center'}>
      {/* <Typography.Title level={3}>Connect Status: {connectStatus}</Typography.Title> */}
      <br />
      {connectStatus === 'INIT' ? (
        <h2>
          <FormattedMessage id="AwsConnect.table.agenttoavailable" defaultMessage="Please wait for the agent to be available." />
        </h2>
      ) : (
        ''
      )}
      <Spin spinning={connectStatus === 'INIT'}>
        <ContainerDiv style={{ display: 'none' }} id="ccp-container"></ContainerDiv>
        <div>
          <Descriptions column={1}>
            <Descriptions.Item label={<FormattedMessage id="AwsConnect.table.contactName" defaultMessage="contactName" />}>
              {contactName}
            </Descriptions.Item>
            <Descriptions.Item label={<FormattedMessage id="AwsConnect.table.phoneNumber" defaultMessage="phoneNumber" />}>
              {phoneNumber}
            </Descriptions.Item>
          </Descriptions>
          {isShowDuration && (
            <div
              id="duration-indicator"
              style={{
                display: 'block',
                fontSize: '22px',
                color: 'white',
                backgroundColor: '#808080',
                borderRadius: '5px',
                padding: '5px',
                textAlign: 'center',
                height: '50px',
                width: '100%',
              }}
            ></div>
          )}
          <GlowingButton
            size="large"
            type="primary"
            block
            glowing={connectStatus === 'CallingCustomer'}
            onClick={() => {
              dailnumber(phoneNumber);
              restart_checker(true, 'CALLING');
              setCallingDisabled(true);
              // goAvailable(); // 听到对方通话的声音
            }}
            disabled={connectStatus === 'INIT' || callingDisabled}
          >
            <FormattedMessage id="AwsConnect.table.callingCustomer" defaultMessage="Calling Customer" />
          </GlowingButton>
          <br />
          <Button
            size="large"
            onClick={() => {
              disconnectContact();
              restart_checker(false);
              setCallingDisabled(false);
            }}
            block
            // callingDisabled
            disabled={connectStatus === 'INIT'}
          >
            <FormattedMessage id="AwsConnect.table.hangUp" defaultMessage="Hang up" />
          </Button>
        </div>
      </Spin>
    </Row>
  );
};

export default AwsConnectModal;
